import { css } from '@huspy/styled-system/css';

const briksTableStyles = {
  root: css({
    borderWidth: '1px',
    borderColor: 'border-secondary',
    borderRadius: 'radius-4',
    borderCollapse: 'separate',
    borderSpacing: 0,
    tableLayout: 'fixed',
  }),
  head: css({
    backgroundColor: 'bg-secondary',
    borderTopRadius: 'radius-4',
    borderCollapse: 'separate',
    borderSpacing: 0,
  }),
  header: css({
    '&:first-child': { borderTopLeftRadius: 'radius-4' },
    '&:last-child': { borderTopRightRadius: 'radius-4' },
    height: 'auto',
    paddingBlock: 0,
    fontSize: 'md',
    letterSpacing: 'md',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'no-wrap',
    color: 'text-primary',
  }),
  cell: css({
    borderTop: '1px solid',
    borderColor: 'border-secondary',
    fontSize: 'md',
    letterSpacing: 'md',
    color: 'text-primary',
    fontWeight: 'medium',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'no-wrap',
  }),
};

export default briksTableStyles;
